import { QueryKey, useQuery, type UseQueryOptions } from '@tanstack/react-query';

import { axiosInstance as axios } from '../config/axios';
import { isValid } from '../utils/queryKeys';

const useFetch = <T>({
	queryKey,
	url,
	queryOptions,
}: {
	queryKey: QueryKey;
	url: string;
	queryOptions?: Omit<UseQueryOptions<T>, 'queryKey' | 'queryFn'>;
}) => {
	const fetchData = async (): Promise<T> => {
		const res = await axios.get<T>(url);
		return res.data;
	};

	const enabled = queryOptions?.enabled !== undefined ? queryOptions.enabled : !!url && isValid(queryKey);

	const { data, isLoading, error } = useQuery<T>({
		queryKey,
		queryFn: fetchData,
		enabled,
		...queryOptions,
	});

	return { data, isLoading, error };
};

export default useFetch;
